import type {ComponentPropsWithRef} from 'react';
import React from 'react';

export type BodyProps = ComponentPropsWithRef<'tbody'>;

export const Body = ({children, ...rest}: BodyProps) => (
    <tbody {...rest}>
        {children}
    </tbody>
);
